import { z } from "zod";
export function cn(...classes) {
  return classes.filter(Boolean).join(' ');
}

/**
 * Reusable validation function for Zod schemas
 * Matches backend validation format
 * @param {z.ZodSchema} schema - Zod schema to validate against
 * @param {Object} data - Data to validate
 * @param {Function} setErrors - State setter function for errors
 * @returns {Object} - Returns { success: boolean, errors: Object }
 */
export const validateSchema = (schema, data, setErrors) => {
  try {
    // Clear previous errors
    setErrors({});

    // Use safeParse instead of parse (matches backend)
    const result = schema.safeParse(data);

    if (!result.success) {
      // Parse the error (matches backend format)
      const error = JSON.parse(result.error);
      
      // Format errors as object with field names as keys
      const formattedErrors = {};
      
      error?.forEach((err) => {
        const field = err.path[0] || "general"; // Fallback to 'general' if no path
        const message = err.message;

        // Handle nested paths (e.g., coordinates.latitude)
        if (err.path && err.path.length > 1) {
          const nestedField = err.path.join(".");
          formattedErrors[nestedField] = message;
        } else {
          formattedErrors[field] = message;
        }
      });

      setErrors(formattedErrors);
      
      return {
        success: false,
        message: "Validation failed",
        errors: formattedErrors,
      };
    }

    // Validation passed
    return {
      success: true,
      data: result.data,
    };
  } catch (error) {
    // Handle unexpected errors
    console.error("Validation error:", error);
    
    const generalError = { general: "An unexpected validation error occurred" };
    setErrors(generalError);
    
    return {
      success: false,
      message: "Validation error occurred",
      errors: generalError,
    };
  }
};

